// Re-export shared EditorDoc ↔ FastAPI wire mappers.
export {
  speakerToWire,
  panelToWire,
  furnitureToWire,
  panelFromWire,
  docToScenePayload,
  docToScene,
  docToRaytraceRequest,
  docToSpeakerSweepRequest,
  docToPanelAbsorptionRequest,
} from '@roomtreatment/api-client';
